import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AwaitModules, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { FadeScrollWrapper } from '@app/styles';
import { ModuleFE_PanelFindings } from '../../../../modules/ModuleFE_PanelFindings/ModuleFE_PanelFindings.js';
import { ModuleFE_Advisor_Action, ModuleFE_Advisor_ContextRule, ModuleFE_Advisor_Expression, ModuleFE_Advisor_FindingView, ModuleFE_Advisor_Tag, ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable, ModuleFE_RuntimeFinding, ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { findingViewType_Parent } from '@app/advisor-ui-shared';
import { Component_FindingView } from '../../../panels/AdvisorPanel_Findings/components/Component_FindingView/Component_FindingView.js';
import './Component_Findings.scss';
import { Component_FindingViews } from '../Component_FindingViews/Component_FindingViews.js';
import { Component_AdvisorSL_Findings } from '../../../loaders/skeleton/findings/Component_AdvisorSL_Findings.js';
const ModulesToAwait_Findings = [
    //Static Modules
    ModuleFE_Advisor_FindingView,
    ModuleFE_Advisor_Variable,
    ModuleFE_Advisor_Value,
    ModuleFE_Advisor_Expression,
    ModuleFE_Advisor_Action,
    ModuleFE_Advisor_ContextRule,
    ModuleFE_Advisor_Tag,
    //Runtime Modules
    ModuleFE_RuntimeFinding,
    ModuleFE_RuntimeOrder,
];
export class Component_Findings extends ComponentSync {
    //######################### Life Cycle #########################
    __onFindingsContextUpdated = () => this.forceUpdate();
    //######################### Logic #########################
    getFindingViewToDisplay = () => {
        const panelState = ModuleFE_PanelFindings.getFindingsPanelState();
        const selectedChildViewId = panelState.parentViewData[panelState.selectedParentViewId]?.selectedChildViewId;
        return ModuleFE_Advisor_FindingView.cache.unique(selectedChildViewId ?? panelState.selectedParentViewId);
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'c__findings', children: [_jsx(Component_FindingViews, {}), _jsx(AwaitModules, { modules: ModulesToAwait_Findings, Component: () => this.render_ViewContent(), customLoader: _jsx(Component_AdvisorSL_Findings, {}) })] });
    }
    //######################### Render - View Content #########################
    render_ViewContent = () => {
        const viewToDisplay = this.getFindingViewToDisplay();
        if (!viewToDisplay || viewToDisplay.type === findingViewType_Parent)
            return _jsx(_Fragment, {});
        return _jsx(FadeScrollWrapper, { scrollRef: this.props.scrollRef, children: _jsx(Component_FindingView, { findingView: viewToDisplay }) });
    };
}
//# sourceMappingURL=Component_Findings.js.map